


























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import PullTo from 'vue-pull-to'

@Component<Scrollable>({ components: { PullTo } })
export default class Scrollable extends Vue {
    private topLoaderClass = 'pull-to-hidden' // default is hidden when not pulling down, so it's not covering other elements

    @Prop({ type: Function, required: false }) public onScrollEnd?: () => void
    @Prop({ type: Function, required: false }) public pullDown?: () => void
    @Prop({type: Boolean, default: false}) public snappy?: boolean
    @Prop({ type: Boolean, default: false }) public bottomPadding?: boolean // Extra padding to avoid overlap with ScreenBottomButton
    @Prop({ type: Number, required: false, default: 0 }) public scrollContainerTop?: number // Used to retain scroll position of vue-pull-to 'scroll-container' div

    // if set, will trigger an initial call of pullDown function to load the data
    @Prop({ type: Boolean, default: false })
    public readonly loading !: boolean

    public mounted() {
        this.watchLoading()
    }

    @Watch('loading')
    public watchLoading() {
        if (this.loading) {
            // hack into the pullToRefresh component to allow initial loading call
            // all component reference are done via this Scrollable, so should be acceptable
            (this.$refs.pullToRefresh as any).$data.distance = 100;
            (this.$refs.pullToRefresh as any).$data.state = 'loading'
        }
    }

    private async topLoadMethod(loaded) {
        if (!this.pullDown) {
            return
        }
        try {
            await this.pullDown()
            loaded('done')
        } catch (e) {
            loaded('fail')
        }
    }

    private async bottomLoadMethod() {
        if (!this.onScrollEnd) {
            return
        }
        await this.onScrollEnd()
    }

    private pullStyle({ state, triggerDistance, diff }) {
        if (!this.pullDown || state !== 'pull') {
            return ''
        }
        const dist = Math.min(diff, triggerDistance)
        const opacity = dist / 100
        return `opacity: ${ opacity }`
    }

    private pullIconStyle({ state, triggerDistance, diff }) {
        if (!this.pullDown) {
            return ''
        }
        // rotate when loading
        if (state === 'loading') {
            return `animation:pull-to-loading-spin 1s linear infinite; opacity: 1`
        }
        const dist = Math.min(diff, triggerDistance)
        const opacity = dist / 100
        return `transform: rotate(${ Math.floor(dist * 5) }deg); opacity: ${ opacity }`
    }

    private get TOP_DEFAULT_CONFIG() {
        return {
            pullText: 'Pull to refresh', // The text is displayed when you pull down
            triggerText: 'Release to refresh', // The text that appears when the trigger distance is pulled down
            loadingText: 'Loading...', // The text in the load
            doneText: 'Success!', // Load the finished text
            failText: 'Failure!', // Load failed text
            loadedStayTime: 400, // Time to stay after loading ms
            stayDistance: 50, // Trigger the distance after the refresh
            triggerDistance: 70, // Pull down the trigger to trigger the distance
        }
    }

    private topStateChanged(state) {
        if (!state) {
            this.topLoaderClass = 'pull-to-hidden'
        } else {
            this.topLoaderClass = 'pull-to-visible'
        }
    }
}

